import * as React from "react";
import { SelectContainer } from "./AccountContainer.style";
import InputMask from 'react-input-mask';
import { Controller } from "react-hook-form";
import { InputStyled, SelectStyled } from "../../elements/forms/InputContainer";
import { useAccountBilling } from "./AccountBilling.use-case";

export const AccountBillingComponent = (): JSX.Element => {
  const _useUseCase = useAccountBilling();

  return (
    <>
      <div className="row">
        <div className="col s12">
          <h2>Faturamento</h2>
        </div>
      </div>
      <div className="row">
        <div className="col s6">
          <Controller
            name="accountBilling.billingType"
            control={_useUseCase.form.control}
            render={({field}) => (
              <SelectContainer className="row">
                <SelectStyled
                  {...field}
                  key={_useUseCase.billingTypeValue}
                  onChange={(billingType: any) => {
                    field.onChange(billingType.value);
                  }}
                  value={_useUseCase.billingTypeValues.find(billingType => billingType.value === field.value)}
                  options={_useUseCase.billingTypeValues}
                  label="Tipo de Faturamento"
                  placeholder="Selecione um tipo"
                  disabled={!_useUseCase.canEdit}
                />                
              </SelectContainer>
            )}
          />
        </div>
        <div className="col s6">
          <div className="input-field">
            <Controller
              key={_useUseCase.billingTypeValue}
              name="accountBilling.documentId"
              control={_useUseCase.form.control}
              render={({field}) => (
                <InputMask
                  {...field}
                  type="tel"
                  mask={_useUseCase.billingTypeValue === 'company' ? '99.999.999/9999-99' : '999.999.999-99'}
                  placeholder={_useUseCase.documentLabel}
                  disabled={!_useUseCase.canEdit}
                />
              )}
            />
            <label>{_useUseCase.documentLabel}</label>
          </div>
        </div>
      </div>
      
      <div className="row">
        <div className="col s6 input-field">
          <Controller
            name="accountBilling.phone"
            control={_useUseCase.form.control}
            render={({field}) => (
              <InputMask
                {...field}
                type="tel"
                mask={'(99) 99999-9999'}
                placeholder="Telefone de Suporte"
              />
            )}
          />
          <label>Telefone de Suporte</label>
        </div>  
        <div className="col s6">
          <Controller
            name="accountBilling.email"
            control={_useUseCase.form.control}
            render={({field}) => (
              <div className="row">
                <InputStyled
                  {...field}
                  s={12}
                  error={_useUseCase.form.formState.errors?.email?.message as any}
                  label="E-mail de Suporte"
                  inputClassName={_useUseCase.form.formState.errors?.email ? "invalid" : " "}
                />
              </div>
            )}
          />
        </div>
      </div>
      <div className="row">
        <div className="col s12">
          <h3>Endereço da Fatura</h3>
        </div>
      </div>
      <div className="row">
        <div className="col s6">
          <div className="input-field">
            <Controller
              name="accountBilling.zipcode"
              control={_useUseCase.form.control}
              render={({field}) => (
                <InputMask
                  {...field}
                  type="tel"
                  mask="99999-999"
                  onBlur={_useUseCase.updateAddressFromZipcode}
                  placeholder="CEP"
                />
              )}
            />
            <label>CEP</label>
          </div>
        </div>
      </div>
      <div className="row">
        <Controller
          name="accountBilling.addressLine1"
          control={_useUseCase.form.control}
          render={({field}) => (
            <InputStyled
              {...field}
              s={12}
              error={_useUseCase.form.formState.errors?.addressLine1?.message as any}
              label="Endereço"
              inputClassName={_useUseCase.form.formState.errors?.addressLine1 ? "invalid" : " "}
            />
          )}
        />
        <Controller
          name="accountBilling.addressLine2"
          control={_useUseCase.form.control}
          render={({field}) => (
            <InputStyled
              {...field}
              s={6}
              error={_useUseCase.form.formState.errors?.addressLine2?.message as any}
              label="Complemento"
              placeholder="Complemento"
              inputClassName={_useUseCase.form.formState.errors?.addressLine2 ? "invalid" : " "}
            />
          )}
        />
        <Controller
          name="accountBilling.neighborhood"
          control={_useUseCase.form.control}
          render={({field}) => (
            <InputStyled
              {...field}
              s={6}
              error={_useUseCase.form.formState.errors?.neighborhood?.message as any}
              label="Bairro"
              inputClassName={_useUseCase.form.formState.errors?.neighborhood ? "invalid" : " "}
            />
          )}
        />
        <Controller
          name="accountBilling.city"
          control={_useUseCase.form.control}
          render={({field}) => (
            <InputStyled
              {...field}
              s={8}
              m={10}
              error={_useUseCase.form.formState.errors?.city?.message as any}
              label="Cidade"
              inputClassName={_useUseCase.form.formState.errors?.city ? "invalid" : " "}
            />
          )}
        />
        <div className="col s4 m2">
            <Controller
              name="accountBilling.state"
              control={_useUseCase.form.control}
              render={({field}) => (
                <SelectContainer>
                <SelectStyled
                  {...field}
                  s={12}
                  onChange={(state: any) => {
                    field.onChange(state.value);
                  }}
                  options={_useUseCase.states}
                  value={_useUseCase.states.find(state => state.value == field.value)}
                  label="UF"
                />
              </SelectContainer>
            )}
          />
        </div>
      </div>
    </>
  );
}